import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getHomePageContext = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/home/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addAlumni = ({ payload, version = 'v1' }) =>
  client
    .request({
      url: `${version}/alumni/add-alum/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getRequestDenialReasons = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alumni-verification-denial-reasons/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getVerificationRequest = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alumni-verification-requests/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const changeVerificationStatus = ({
  requestId,
  payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/alumni/alumni-verification-requests/${requestId}`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const sendVerificationRequest = ({ hashId, data, version = 'v1' }) =>
  client
    .request({
      url: `${version}/alumni/alumni-verification-requests/${hashId}/`,
      method: RequestMethod.PUT,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMobileVerificationRequest = ({ hashId, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/alumni/alumni-verification-requests/${hashId}/mobile-upload/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumInformation = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/alumni/alum/claim/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumStaffRosters = ({ version = 'v1', alumUuid }) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/rosters/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumTags = ({ version = 'v1', alumUuid }) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/tags/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumniTagList = ({ version = 'v1', params = {} }) =>
  client
    .request({
      url: `${version}/alumni/tags/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createPlaceholderUser = ({ version = 'v1', alumUuid }) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/placeholder-user/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyWindowCompletion = ({
  version = 'v1',
  surveyUuid,
  windowUuid,
}) =>
  client
    .request({
      url: `${version}/alumni/survey/${surveyUuid}/window/${windowUuid}/completion-data/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const postVerificationRequest = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alumni-verification-requests/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createVerificationRequest = async ({
  data: payload,
  version = 'v1',
} = {}) => {
  const { data } = await postVerificationRequest();
  return client
    .request({
      url: `${version}/alumni/alumni-verification-requests/${data?.hashId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const getSurveyList = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/alumni/survey/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyDetail = ({ uuid, version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/alumni/survey/${uuid}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSurveyWindow = ({ version = 'v1', surveyUuid, data }) =>
  client
    .request({
      url: `${version}/alumni/survey/${surveyUuid}/window/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createAlumSurvey = ({ version = 'v1', data }) =>
  client
    .request({
      url: `${version}/alumni/survey/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSurveyWindow = ({
  version = 'v1',
  surveyUuid,
  windowUuid,
  data,
}) =>
  client
    .request({
      url: `${version}/alumni/survey/${surveyUuid}/window/${windowUuid}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteAlumniSurvey = ({ uuid, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/survey/${uuid}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumniFilterContext = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/search-context/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumniSurveyWindow = ({
  surveyUuid,
  windowUuid,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/alumni/survey/${surveyUuid}/window/${windowUuid}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createAlumniInfo = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/alumni/alum/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const retrieveAlumniContactInfo = ({ alumId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/contact-info/${alumId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateAlumniContactInfo = async ({
  alumniId,
  data: payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/alumni/contact-info/${alumniId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateAlumni = async ({
  alumUuid,
  data: payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getRostersList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/rosters/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumniList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumniDetail = ({
  alumUuid,
  params = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateAlumniRecord = ({ version = 'v1', id, payload }) =>
  client
    .request({
      url: `${version}/alumni/add-alum/${id}`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to get notes
 * @param alumUuid
 * @param params - filters applied to list
 */
export const getNotes = ({ alumUuid, version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/notes/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to create note
 * @param alumUuid
 * @param payload.description
 * @param payload.duration
 * @param payload.hasFollowUp
 * @param payload.isVisibilityRestricted
 * @param payload.meetingDate
 * @param payload.recordType
 * @param payload.reminderDate
 * @param payload.tags
 * @param payload.title
 */
export const createNote = ({ alumUuid, version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/notes/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to update note
 * @param alumUuid
 * @param noteId
 * @param payload.description
 * @param payload.duration
 * @param payload.hasFollowUp
 * @param payload.isVisibilityRestricted
 * @param payload.meetingDate
 * @param payload.recordType
 * @param payload.reminderDate
 * @param payload.tags
 * @param payload.title
 */
export const updateNote = ({
  alumUuid,
  noteId,
  version = 'v1',
  payload,
} = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/notes/${noteId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to delete note
 * @param alumUuid
 * @param noteId
 */
export const deleteNote = ({ alumUuid, noteId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/${alumUuid}/notes/${noteId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAlumniDistrict = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/alumni/alum/district/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
